// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { AddressInfoDisplayStyles } from "@insite/content-library/Components/AddressInfoDisplay";
import { TypographyProps } from "@insite/mobius/Typography";
import { css } from "styled-components";

export const xLocationAddressStyle: TypographyProps = {
    size: 14,
    lineHeight: "22px",
    color: "common.ui6",
};

const AddressSharedStyles: { address: AddressInfoDisplayStyles; warehouseNameText: TypographyProps } = {
    address: {
        wrapper: {
            css: css`
                display: flex;
                flex-direction: column;
                @media print {
                    display: inline-block;
                }
            `,
        },
        address1Text: xLocationAddressStyle,
        address2Text: xLocationAddressStyle,
        address3Text: xLocationAddressStyle,
        address4Text: xLocationAddressStyle,
        attentionText: xLocationAddressStyle,
        cityText: xLocationAddressStyle,
        companyNameText: xLocationAddressStyle,
        faxText: xLocationAddressStyle,
        firstNameText: xLocationAddressStyle,
        lastNameText: xLocationAddressStyle,
        postalCodeText: xLocationAddressStyle,
        stateText: xLocationAddressStyle,
        cityStatePostalCodeText: xLocationAddressStyle,
        countryText: xLocationAddressStyle,
        customerNameText: xLocationAddressStyle,
        phoneText: {
            ...xLocationAddressStyle,
            css: css`
                margin-top: 8px;
            `,
        },
        emailText: {
            ...xLocationAddressStyle,
            css: css`
                margin-top: 8px;
            `,
        },
    },
    warehouseNameText: xLocationAddressStyle,
};

export default AddressSharedStyles;
